import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { InsurerProgressStatus } from "src/app/share/constants/quotation-progress";

const TICK_STAGGER_MS = 150;

@Component({
  selector: "app-progress-status-icon",
  templateUrl: "./status-icon.component.html",
  styleUrls: ["./status-icon.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressStatusIconComponent {
  @Input() status: InsurerProgressStatus;
  // null = already Ready when the page loaded, so the tick skips its entrance
  @Input() readyOrder: number | null = null;
  @Input() pulse = true;

  get tickDelay(): string {
    return `${(this.readyOrder ?? 0) * TICK_STAGGER_MS}ms`;
  }
}
